import React, { useLayoutEffect, useRef } from 'react';

// Keep native table markup and derive mobile card labels from its real headers.
export default function ResponsiveTable({ children, className = '', ...props }: React.TableHTMLAttributes<HTMLTableElement>) {
  const ref = useRef<HTMLTableElement>(null);
  useLayoutEffect(() => {
    const table = ref.current;
    if (!table) return;
    const labels = Array.from(table.tHead?.rows[0]?.cells || []).map(c => c.textContent || '');
    for (const body of Array.from(table.tBodies)) for (const row of Array.from(body.rows)) {
      let column = 0;
      for (const cell of Array.from(row.cells)) { cell.dataset.label = cell.colSpan > 1 ? '' : labels[column] || ''; column += cell.colSpan; }
    }
  });
  return <table {...props} ref={ref} className={`responsive-table ${className}`}>{children}</table>;
}
